import { useEffect, useState } from 'react';
import { fetchPolicies } from '../api/client';
import type { PolicyVersions } from '../api/types';

/**
 * 利用規約・プライバシーポリシーの本文の頭に出す「版」と「最終更新日」（doc/AUTH.md §13）。
 *
 * 版の正はサーバ（services/api/src/lib/terms.ts）1 か所で、ここは `GET /v1/policies` から受け取るだけ。
 * 本文（このリポジトリの TermsPage / PrivacyPage）と版は同じイメージで一緒に配られるので、必ず揃う。
 * 取れなかったときは何も出さない（本文は読めるので、日付だけのために画面を止めない）。
 */
export function PolicyMeta({ kind }: { readonly kind: 'terms' | 'privacy' }) {
  const [versions, setVersions] = useState<PolicyVersions | null>(null);

  useEffect(() => {
    let alive = true;
    void fetchPolicies().then((value) => { if (alive) setVersions(value); }).catch(() => undefined);
    return () => { alive = false; };
  }, []);

  if (!versions) return null;
  const { version, updatedAt } = versions[kind];
  return (
    <p className="policy__meta">
      版 {version}<span aria-hidden="true"> ／ </span>最終更新日 {updatedAt}
    </p>
  );
}
